import styled, { css } from 'styled-components'
import { Link, TableComponents } from '@sketch/components'

import BaseFooter from 'components/Footer'
import { DocumentGridItem, GridFocusStyles } from '../DocumentItem'

import { breakpoint } from '@sketch/global-styles'

const headerStyles = css`
  border-bottom: ${({ theme }) => `1px solid ${theme.colors.border.A}`};
  position: sticky;
  top: 54px; /* Height of the Header + the Margin */
  z-index: ${({ theme }) => theme.zIndex[2]};
  background: ${({ theme }) => theme.colors.background.secondary.A};

  ::before {
    position: absolute;
    content: '';
    background: ${({ theme }) => theme.colors.background.secondary.A};
    width: 100%;
    height: 100%;
    left: 0;
    bottom: 0;
    z-index: -1;

    /* Create the spacing of the margin */
    padding-top: 16px;
    box-sizing: content-box;

    ${breakpoint('sm')`
      padding-top: 40px;
    `}
  }

  ${breakpoint('sm')`
    top: 78px; /* Height of the Header + the Margin */
  `}
`

export const HeaderTableCell = styled(TableComponents.TableHeaderCell)`
  ${headerStyles}
`

export const ActionTableCell = styled(TableComponents.TableCell)`
  ${headerStyles};

  width: 64px;
  background: ${({ theme }) =>
    theme.colors.background.secondary.A}; /** Just for hiding the text */
`

export const TableWrapper = styled.div<{
  $hideProjects: boolean
}>`
  margin: 0 -16px;

  ${breakpoint('sm')`
    margin: 0 -40px;
  `}

  /* Compensate for the Margin and make the table scroll without blank sides */
  ${TableComponents.Table} {
    min-width: 800px;
    padding-left: 16px;
    padding-right: 16px;

    ${breakpoint('sm')`
      padding: 0 40px;
    `}
  }

  ${TableComponents.TableHeaderCell} {
    &:nth-child(1),
    &:nth-child(4) {
      width: 30%;
    }

    &:nth-child(2),
    &:nth-child(3) {
      width: 20%;
    }
  }

  ${TableComponents.TableRow} {
    cursor: pointer;
  }

  ${breakpoint('base', 'sm')`
    ${css`
      ${TableComponents.TableHeaderCell} {
        min-width: 120px;
        max-width: 200px;
      }
    `}
  `}

  ${({ $hideProjects }) =>
    $hideProjects &&
    css`
      ${TableComponents.TableHeaderCell}:nth-child(2) {
        display: none;
      }

      ${TableComponents.TableRow} ${TableComponents.TableCell}:nth-child(2) {
        display: none;
      }

      /* We need this to make the action column here
      to be at the end of the table */
      && {
        ${TableComponents.TableHeaderCell} {
          width: 33%;
        }
      }
    `}
`

export const FocusLink = styled(Link)`
  display: block; /* Needed to avoid cutting focus ring when using a keyboard */

  &:focus ${DocumentGridItem} {
    ${GridFocusStyles};
  }
`

export const Footer = styled(BaseFooter)`
  margin-top: auto;
`
